import React, { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import ProfileIcon from "../ContentManagerPages/ProfileIcon";
import ProfileModal from "../ContentManagerPages/ProfileModal";
import "./ContentManagerLayout.css";

export default function ContentManagerLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [profileOpen, setProfileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="cm-wrapper">
      <aside className="cm-sidebar">
        <h2 className="cm-brand">
          <ProfileIcon onClick={() => setProfileOpen(true)} />
          <span>Content Manager</span>
        </h2>

        <ul>
          <li>
            <NavLink to="dashboard">Dashboard</NavLink>
          </li>

          <li>
            <NavLink to="blogposts">Blog Posts</NavLink>
          </li>

          <li>
            <NavLink to="images">Images</NavLink>
          </li>
        </ul>

        <button className="cm-logout-btn" type="button" onClick={handleLogout}>
          <span>Log Out</span>
          <span className="cm-logout-icon-wrap">
            <LogOut size={18} className="cm-logout-icon" />
          </span>
        </button>
      </aside>

      <main className="cm-content">
        <Outlet />
      </main>

      <ProfileModal open={profileOpen} onClose={() => setProfileOpen(false)} />
    </div>
  );
}
